import React, { Component } from 'react';
import { withStyles, Grid } from '@material-ui/core';
import { injectIntl, FormattedMessage } from 'react-intl';

import HUBContext from '../services/HUBContext';

const styles = theme => ({
    alert: {
        color: '#856404',
        backgroundColor: '#fff3cd',
        padding: '.75rem 1.25rem',
        marginBottom: '1rem',
        border: '1px solid #ffeeba',
        borderRadius: '.25rem'
    },
    leftAlign: {
        textAlign: 'left'
    },
    ul: {
        marginLeft: '1rem'
    }
});

export class BadRequest extends Component {

    render() {
        const { classes } = this.props;
        const { response } = this.props;

        if (!response)
            return (<Grid container className={ classes.alert }>
                        <Grid item xs={12} sm={12} lg={12} xl={12}>
                            <FormattedMessage id='badRequest' defaultMessage='Bad Request' />
                        </Grid>
                    </Grid>);

        let title = '';
        if (!!response.data && !!response.data.title)
        title = response.data.title;

        let errors = [];
        if (!!response.data && !!response.data.errors) {
            for (const prop in response.data.errors) {
                for (const err in response.data.errors[prop])
                    errors.push(response.data.errors[prop][err]);
            }
        }

        if (errors.length <= 0 &&
            !response.data.errors && 
            typeof response.data === 'object' && 
            !!response.data[""]) {
            errors = response.data[""];
        }

        return (<Grid container className={ classes.alert }>
            <Grid item xs={12} sm={12} lg={12} xl={12} className={ classes.leftAlign }>
                <strong>{ title }</strong>
                
                <ul className={ classes.ul }>
                    { errors.map((o, i) => { return (<li key={`lierr${i}`}>{ o }</li>); })}
                </ul>
            </Grid>
        </Grid>);
    }

}

BadRequest.contextType = HUBContext;

export default withStyles(styles)(injectIntl(BadRequest));